import { Action } from 'redux';
import { Epic } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import { concat as concat$ } from 'rxjs/observable/concat';
import { from as from$ } from 'rxjs/observable/from';
import {
    ACTION_TRIALITEMINSTANCEIMPORT_LOAD_BY_ID,

    ACTION_TRIALITEMINSTANCEIMPORT_SAVE,

    ITrialItemInstanceImportLoadByIdAction,
    ITrialItemInstanceImportLoadFailureAction,
    ITrialItemInstanceImportLoadSuccessAction,

    ITrialItemInstanceImportSaveAction,
    ITrialItemInstanceImportSaveSuccessAction,
    ITrialItemInstanceImportSaveFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

} from "../actions/trialItemInstanceImport";
import { trialItemInstanceImportApi } from "../services/trialItemInstanceImport";


export const
    getTrialItemInstanceImportByIdEpic = (action$): Observable<ITrialItemInstanceImportLoadSuccessAction | ITrialItemInstanceImportLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALITEMINSTANCEIMPORT_LOAD_BY_ID)
            .mergeMap((action: ITrialItemInstanceImportLoadByIdAction) => {
                return trialItemInstanceImportApi
                    .getTrialItemInstanceImportById(action.id, action.trialId)
                    .map(response =>
                        LoadSuccess(response.trialItemInstanceImport, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialItemInstanceImportEpic = (action$): Observable<ITrialItemInstanceImportSaveSuccessAction | ITrialItemInstanceImportSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALITEMINSTANCEIMPORT_SAVE)
            .mergeMap((action: ITrialItemInstanceImportSaveAction) => {
                return trialItemInstanceImportApi
                    .setTrialItemInstanceImport(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialItemInstanceImport, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    };

